import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
var PinSearchbarService = /** @class */ (function () {
    function PinSearchbarService() {
        this.pinSearchbarClickedEvent = new EventEmitter();
    }
    PinSearchbarService.prototype.pinSearchbarClicked = function (pinned) {
        this.pinSearchbarClickedEvent.emit(pinned);
    };
    PinSearchbarService.ngInjectableDef = i0.defineInjectable({ factory: function PinSearchbarService_Factory() { return new PinSearchbarService(); }, token: PinSearchbarService, providedIn: "root" });
    return PinSearchbarService;
}());
export { PinSearchbarService };
